<!-- eslint-disable @angular-eslint/template/interactive-supports-focus, @angular-eslint/template/alt-text -->
<div class="agpr-contacts" role="group" aria-label="Contacts Block">
  <div class="agpr-contacts-emptyContainer agpr-contextMenu-parent" *ngIf="(dataSource.all() | async)?.length==0" (click)="onEdit()">
    <ul role="menu" class="agpr-contextMenu top right" [attr.aria-describedby]="errorsId">
      <li role="menuitem">
        <agpr-button
          icon="fa-regular fa-duotone fa-trash-can"
          (click)="onDelete()"
          [tooltip]="'PageBuilder.briefings.blockIcon.delete'"
          [style]="buttonTypes.contextMenu"
        ></agpr-button>
      </li>
      <li role="menuitem">
        <agpr-button
          icon="fa-regular fa-duotone fa-pen"
          (click)="onEdit()"
          [tooltip]="'PageBuilder.briefings.blockIcon.edit'"
          [style]="buttonTypes.contextMenu"
        ></agpr-button>
      </li>
    </ul>
    <span class="agpr-contacts-boxLabel">
      <span class="fa fa-address-card-o agpr-contacts-boxLabelIcon" aria-hidden="true">
      </span>
      <span class="agpr-contacts-boxLabelText">
        Contact
      </span>
    </span>
  </div>
  <ul class="agpr-contacts-list" *ngIf="(dataSource.all() | async)?.length > 0">
    <li
        class="{{!isDisabled ?'agpr-contacts-listItem':''}} agpr-contextMenu-parent"
        *ngFor="let item of dataSource.all() | async; index as iCount; let last = last; let total = count"
    >
      <div *ngIf="iCount<maxContactItems" role="group" [attr.aria-label]="(item.name ? item.name : 'Empty') + ' Contact'">
        <div *ngIf="textIndex==iCount then textMode else normalMode"></div>
        <ng-template #textMode>
            <div
                id="contactTextMain"
                class="agpr-contacts-form"
                (clickOutside)="unselect()"
                [clickOutsideEnabled]="textIndex==iCount"
                [delayClickOutsideInit]="true"
            >
                <div class="agpr-contacts-image">
                    <agpr-browse-image
                        (getImageUrl)="getBrowsedImage($event,item,iCount)"
                        (getImageError)="emitImageError($event)"
                        [showPlaceholder]="showImagePlaceholder"
                        [imageUrl]="item.imageData"
                        [imageId]="item.imageId"
                        imageClass="agpr-browseImage-contactLogo"
                        [placeholderWidth]="imageWidth"
                        [placeholderHeight]="imageHeight"
                        [showImageHtml]="showContactImageHtml"
                        [showImageInput]="showContactImageInput"
                        [showDeleteButton]="!isDisabled"
                        [isContact]="true"
                        [isDisabled]="isDisabled"
                        borderClass="agpr-browseImage-contactLogo"
                        ariaLabel="Contact"
                    >
                    </agpr-browse-image>
                </div>
                <div class="agpr-contacts-formBlock">
                    <div class="agpr-contacts-name">
                        <agpr-text-input
                            [maxlength]="128"
                            [label]="localization.contactName"
                            [(ngModel)]="item.name"
                            (ngModelChange)="onContactInput(item, iCount)"
                            id="contactName_{{iCount}}"
                            ariaDescribedBy="contact_name_{{iCount}}_error"
                            [required]="true"
                        ></agpr-text-input>
                        <agpr-form-message
                            *ngIf="showPublishErrors && mandatory.name && (!item.name || item.name.trim().length === 0)"
                            id="contact_name_{{iCount}}_error"
                        >
                            {{ localization.requiredNameErrorMessage }}
                        </agpr-form-message>
                    </div>
                    <div class="agpr-contacts-title">
                        <agpr-text-input
                            [maxlength]="128"
                            [label]="localization.contactTitle"
                            [(ngModel)]="item.title"
                            (ngModelChange)="onContactInput(item, iCount)"
                            id="contactTitle_{{iCount}}"
                            ariaDescribedBy="contact_title_{{iCount}}_error"
                        ></agpr-text-input>
                        <agpr-form-message
                            *ngIf="showPublishErrors && mandatory.title && (!item.title || item.title.trim().length === 0)"
                            id="contact_title_{{iCount}}_error"
                        >
                            {{ localization.requiredTitleErrorMessage }}
                        </agpr-form-message>
                    </div>
                    <div class="agpr-contacts-email">
                        <agpr-text-input
                            [maxlength]="256"
                            [label]="localization.contactEmail"
                            [(ngModel)]="item.emailAddress"
                            (ngModelChange)="emailValidation(item);onContactInput(item, iCount)"
                            id="contactEmail_{{iCount}}"
                            ariaDescribedBy="contactEmail_{{iCount}}_errors"
                            [required]="required"
                        ></agpr-text-input>
                        <ul id="contactEmail_{{iCount}}_errors">
                            <li *ngIf="showPublishErrors && mandatory.emailAddress && (!item.emailAddress || item.emailAddress?.trim().length === 0)">
                                <agpr-form-message>
                                    {{ localization.requiredEmailErrorMessage }}
                                </agpr-form-message>
                            </li>
                            <li *ngIf="(showPublishErrors || showDraftErrors) && (item.emailAddress && !item.validEmail)">
                                <agpr-form-message>
                                    {{ localization.contactEmailErrorMessage }}
                                </agpr-form-message>
                            </li>
                        </ul>
                    </div>
                    <div class="agpr-contacts-address">
                        <agpr-text-input
                            [maxlength]="256"
                            [label]="localization.contactAddress"
                            [(ngModel)]="item.address"
                            (ngModelChange)="onContactInput(item, iCount)"
                            id="contactAddress_{{iCount}}"
                            ariaDescribedBy="contact_address_{{iCount}}_error"
                        ></agpr-text-input>
                        <agpr-form-message
                            *ngIf="showPublishErrors && mandatory.contactAddress && (!item.contactAddress || item.contactAddress.trim().length === 0)"
                            id="contact_address_{{iCount}}_error"
                        >
                            {{ localization.requiredAddressErrorMessage }}
                        </agpr-form-message>
                    </div>
                    <div class="agpr-contacts-phone">
                        <agpr-text-input
                            [maxlength]="32"
                            [label]="localization.contactPhone"
                            [(ngModel)]="item.phoneNumber"
                            (ngModelChange)="onContactInput(item, iCount)"
                            id="contactPhone_{{iCount}}"
                            ariaDescribedBy="contact_phone_{{iCount}}_error"
                            [required]="required"
                        ></agpr-text-input>
                        <agpr-form-message
                            *ngIf="showPublishErrors && mandatory.phoneNumber && (!item.phoneNumber || item.phoneNumber.trim().length === 0)"
                            id="contact_phone_{{iCount}}_error"
                        >
                            {{ localization.requiredPhoneErrorMessage }}
                        </agpr-form-message>
                    </div>
                    <div class="agpr-contacts-mobile">
                        <agpr-text-input
                            [maxlength]="32"
                            [label]="localization.contactMobile"
                            [(ngModel)]="item.mobileNumber"
                            (ngModelChange)="onContactInput(item, iCount)"
                            id="contactMobile_{{iCount}}"
                            ariaDescribedBy="contact_mobile_{{iCount}}_error"
                        ></agpr-text-input>
                        <agpr-form-message
                            *ngIf="showPublishErrors && mandatory.mobileNumber && (!item.mobileNumber || item.mobileNumber.trim().length === 0)"
                            id="contact_mobile_{{iCount}}_error"
                        >
                            {{ localization.requiredMobileErrorMessage }}
                        </agpr-form-message>
                    </div>
                    <div class="agpr-contacts-url">
                        <agpr-text-input
                            [maxlength]="512"
                            [label]="localization.contactWebAddress"
                            [(ngModel)]="item.webAddress"
                            (ngModelChange)="onContactInput(item, iCount)"
                            id="contactWebAddress_{{iCount}}"
                            ariaDescribedBy="contact_webaddress_{{iCount}}_error"
                        ></agpr-text-input>
                        <agpr-form-message
                            *ngIf="showPublishErrors && mandatory.webAddress && (!item.webAddress || item.webAddress.trim().length === 0)"
                            id="contact_webaddress_{{iCount}}_error"
                        >
                            {{ localization.requiredAddressErrorMessage }}
                        </agpr-form-message>
                    </div>
                    @if (showRequiredMessage) {
                        <div class="agpr-contacts-message">
                            <agpr-message
                                severity="info"
                            >
                                <div [innerHTML]="localization.contactRequiredInfo"></div>
                            </agpr-message>
                    </div>
                    }
                </div>
            </div>
        </ng-template>
        <ng-template #normalMode>
          <div class="agpr-contacts-form" (click)="openContactBlock(iCount, item);">
            <ul
              *ngIf="!isDisabled"
              class="agpr-contextMenu top right"
              role="menu"
              [attr.aria-describedby]="errorsId"
            >
              <li
                *ngIf="total > minContactItems"
                role="menuitem"
              >
                <agpr-button
                  class="agpr-contacts-listItem-buttons"
                  icon="fa-regular fa-duotone fa-trash-can"
                  (click)="delete(item)"
                  tooltip="PageBuilder.briefings.blockIcon.delete"
                  [style]="buttonTypes.contextMenu"
                >
                </agpr-button>
              </li>
              <li
                role="menuitem"
              >
                <agpr-button
                  class="agpr-contacts-listItem-buttons"
                  icon="fa-regular fa-duotone fa-pen"
                  (click)="edit(item, iCount)"
                  tooltip="PageBuilder.briefings.blockIcon.edit"
                  [style]="buttonTypes.contextMenu"
                >
                </agpr-button>
              </li>
              <li
                *ngIf="last && total < maxContactItems"
                role="menuitem"
              >
                <agpr-button
                  icon="fa-regular fa-duotone fa-plus"
                  (click)="add(iCount)"
                  tooltip="PageBuilder.briefings.blockIcon.addBlock"
                  [style]="buttonTypes.contextMenu"
                >
                </agpr-button>
              </li>
            </ul>

            <div class="agpr-contacts-imageContainer">
              <img
                class="agpr-contacts-image"
                *ngIf="showImageNormalMode && ((item.imageData != null && item.imageData != '') ||
                    (item.imageId != null && item.imageId != ''))"
                [src]="item.imageData != null && item.imageData != '' ? convertBase64ToImage(item.imageData) : getImageUrlBasedOnImageID(item.imageId)"
              />
                  <img
                      *ngIf="(item.imageData == null || item.imageData == '') &&
                          (item.imageId == null || item.imageId == '')"
                      src="/app/assets/images/userimg.jpg" width="70" height="70"
                  />
            </div>

            <div class="agpr-contacts-formBlock agpr-contacts-formBlock--readonly">
                <div class="agpr-contacts-snippet agpr-contacts-name agpr-contacts-bold">
                    {{item.name}}
                </div>
                <div class="agpr-contacts-snippet agpr-contacts-title">
                    {{item.title}}
                </div>
                <div class="agpr-contacts-snippet agpr-contacts-email agpr-contacts-highLight">
                    {{item.emailAddress}}
                </div>
                <div class="agpr-contacts-snippet agpr-contacts-address">
                    {{item.address}}
                </div>

                <div
                    *ngIf="item.phoneNumber != null && item.phoneNumber != ''"
                    class="agpr-contacts-snippet agpr-contacts-phone"
                >
                    {{localization.contactWork}}
                    <span class="agpr-contacts-highLight">{{item.phoneNumber}}</span>
                </div>
                <div
                    *ngIf="item.mobileNumber != null && item.mobileNumber != ''"
                    class="agpr-contacts-snippet agpr-contacts-mobile"
                >
                    {{localization.contactMobilelbl}}
                    <span class="agpr-contacts-highLight">{{item.mobileNumber}}</span>
                </div>
                <div class="agpr-contacts-snippet agpr-contacts-url agpr-contacts-highLight">
                    {{item.webAddress}}
                </div>
            </div>
          </div>
        </ng-template>
      </div>
    </li>
  </ul>
</div>
